import React from 'react';
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import dataCard from '../assets/fake-data/data-card';
import dataFaq from '../assets/fake-data/data-faq';
import dataServicesHighlight from '../assets/fake-data/data-services-highlight';
import dataMontono from '../assets/fake-data/data-montono';

import dataBestRooms from '../assets/fake-data/data-best-rooms';

import About from '../components/layouts/About';
import Action from '../components/layouts/Action';
import FAQ from '../components/layouts/FAQ';

import Speciality from '../components/layouts/Speciality';
import Especialidades from '../components/layouts/Especialidades';
import Servicios from '../components/layouts/Servicios';
import SliderOne from '../components/slider/SliderOne';
import LocationSection from '../components/layouts/LocationSection';
import BestRooms from '../components/layouts/BestRooms';
import TouristPlaces from '../components/layouts/TouristPlaces';
import dataTouristPlaces from '../assets/fake-data/data-tourist-places';
const Home01 = () => {
    return (
        <div>
            <Header />
            <SliderOne />
            <BestRooms data={dataBestRooms} />
            <About />

            <Speciality data={dataCard} />
            <Especialidades data={dataServicesHighlight} />

            <Servicios data={dataMontono} />

            <Action />

            <TouristPlaces data={dataTouristPlaces} />

            <LocationSection />

            <section className="map">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <p data-aos="fade-up"><iframe title='map' src="https://maps.google.com/maps?q=Catamarca%2072,%20San%20Miguel%20de%20Tucum%C3%A1n&hl=es&z=17&output=embed" width="100%" height="450" allowFullScreen="" loading="lazy" style={{ border: 0 }}></iframe></p>
                        </div>
                    </div>
                </div>
            </section>
            <FAQ data={dataFaq} />
            <Footer />

        </div>
    );
}

export default Home01;